import { Component, OnInit, Input, HostBinding } from '@angular/core';

@Component({
  selector: 'download-button',
  templateUrl: './download-button.component.html',
  styleUrls: ['./download-button.component.sass']
})
export class DownloadButtonComponent implements OnInit {

  public buttonLabel = "label" ;
  @Input ( ) label: string ;
  @Input ( ) link: string ;
  @HostBinding('class.downloadButton') enableDownloadClass = true;

  constructor() { 

  }

  ngOnInit() {
    this.buttonLabel = this.label || this.buttonLabel; 
    
  }

}
